import {
  fun_PostAction,
  fun_GetAction,
  fun_Download,
  fun_UploadImg
} from "@/api/index";
import { fun_DownloadFile, fun_GetKeys } from "@/utils/validate.js";
import { Loading } from "element-ui";
export default {
  data() {
    const fileMustUpload = (rule, value, callback) => {
      if (!value) {
        // 未上传文件
        callback(new Error("请上传文件！"));
      }
      callback();
    };
    return {
      // 列表loading状态
      loading: false,
      // 默认打开折叠页
      activeNames: ["1"],
      // 表单绑定值
      form: {
        corpName: null, // 用户名称
        pictureInfo: null, // 附件类型
        pictureName: null, // 附件名称
        fileName: null, // 文件名
        pictureFiles: [] // 文件列表
      },
      rules: {
        pictureInfo: [
          {
            required: true,
            message: "请选择附件类型",
            trigger: "change"
          }
        ],
        pictureName: [
          {
            required: true,
            message: "请输入附件名称",
            trigger: "blur"
          }
        ]
      },
      // 用于验证是否上传文件
      fileName: null,
      // 默认选否
      radio: 0,
      // 表格按钮
      btnList: [
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "附件类型",
          prop: "pictureInfo"
        },
        {
          label: "附件名称",
          prop: "pictureName"
        },
        {
          label: "状态",
          prop: "state"
        },
        {
          label: "添加时间",
          prop: "insertDate"
        },
        {
          label: "操作",
          slotName: "cz"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      // 勾选的数组
      multipleSelection: [],
      // 附件下载的路径
      fileUrl: null,
      // 全局加载
      fullLoading: null,
      // 弹出框默认关闭
      dialogVisible: false,
      // 核验意见
      auditOpinion: null,
      // 登录角色标识
      userFlag: sessionStorage.getItem("userFlag"),
      userType: sessionStorage.getItem("userType"), // 用户类型
    };
  },
  // 接收父组件传递的数据
  props: {
    // 页面类型
    params: {
      type: Object,
      default: {}
    }
  },
  // 模板编译完成
  mounted() {
    // 判断是注册人
    if(sessionStorage.getItem("userType") === "201508061647510026" || this.userFlag === '工作人员'){
      // 获取id
      this.params.id = this.$route.query.id;
      // 获取flag
      this.params.flag = this.$route.query.flag;
    }
    // 获取详情
    this.fun_Details();
    // 获取列表详情
    this.fun_GetList();
    // 获取附件下载的路径
    this.fun_GetFileUrl();
  },
  // 自定义方法
  methods: {
    /**
     * 获取CA办理资料详情
     * @author shuhua
     */
    fun_Details() {
      // 发起请求
      fun_GetAction("/caCertificateFile/detail", {
        id: this.params.id,
        flag: this.params.flag
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取文件模板路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "武招通网上预约CA办理表-----仅为武招通网上预约使用"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 附件下载路径
          this.fileUrl = data;
        }
      });
    },
    /**
     * 单选框值改变事件
     * @author shuhua
     */
    fun_ChangeRadio(e) {
      // 将选中单选框的值存入session
      sessionStorage.setItem("radioValue", e);
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_Change(e) {
      // 赋值
      this.form.pictureInfo = e.code;
    },
    /**
     * 文件上传
     */
    fun_FileDetail(file, fileList) {
      // 获取文件后缀名
      const suffix = file.name.split(".")[1].toLowerCase();
      // 判断文件是否小于30MB
      if (
        suffix !== "jpg" &&
        suffix !== "png" &&
        suffix !== "jpeg" &&
        suffix !== "gif"
      ) {
        // 清除验证不通过的文件
        this.fileName = null;
        this.form.pictureFiles = [];
        // 提示错误消息
        this.$message.error("图片格式有误，请上传jpg或gif或png格式的图片！");
        // 返回
        return false;
      }
      // 加入集合
      this.form.pictureFiles = [file];
      // 获取文件名
      this.$set(this.form, "fileName", file.name);
      // 清空提示
      this.fileName = null;
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction("/caCertificateFile/list", {
        ...this.reqPageData,
        id: this.params.id,
        inputPerson: this.params.id,
        flag: this.params.flag
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },

    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "删除":
          // 执行删除的方法
          this.fun_Del();
          break;
      }
    },
    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 操作标识
          let rtn = false;
          // 遍历
          this.multipleSelection.forEach(e => {
            if (e.state === "核验通过") {
              rtn = true;
              return false;
            }
          });
          // 如果有已核验的数据不允许删除
          if (rtn) {
            // 未勾选，则提示
            this.$alert(
              "勾选的数据存在已核验的数据，不能进行删除，请检查后重试！",
              "warning"
            );
            return false;
          }
          // 获取keys
          const keys = fun_GetKeys(this.multipleSelection);
          // 发起请求
          fun_GetAction("/caCertificateFile/delete?keys=" + keys).then(res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 操作成功
            if (result) {
              // 重新加载列表
              this.fun_GetList();
              // 操作成功
              this.$message.success(msg);
            } else {
              // 错误消息提示
              this.$message.error(msg);
            }
          });
        });
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 上传文件
     * @author shuhua
     */
    fun_Submit() {
      // 验证表单
      this.$refs["form"].validate(valid => {
        // 验证是否上传文件
        if (!this.form.fileName) {
          this.fileName = "请上传文件！";
        }
        // 验证通过
        if (valid) {
          // 提交表单
          var formData = new FormData();
          // 附件文件
          formData.append("file", this.form.pictureFiles[0].raw);
          // 数据编号
          formData.append("recordNumber", this.params.id);
          // 标识
          formData.append("flag", "0");
          // 用户名称
          formData.append("userName", this.form.corpName);
          // 附件类型
          formData.append("pictureInfo", this.form.pictureInfo);
          // 附件名称
          formData.append("pictureName", this.form.pictureName);
          // 打开遮罩
          this.fun_Loading();
          // 上传文件至服务器
          fun_UploadImg("/caCertificateFile/upload", formData, 0).then(res => {
            // 解构res.data
            const { result, msg, data } = res.data;
            // 操作成功
            if (result) {
              // 清空文件类型
              this.form.pictureInfo = "";
              // 清空附件名称
              this.form.pictureName = "";
              // 清空文件列表
              this.form.pictureFiles = [];
              // 清空上传的文件名
              this.form.fileName = null;
              // 刷新一览
              this.fun_GetList();
              // 加载框取消
              this.fullLoading.close();
            } else {
              // 加载框取消
              this.fullLoading.close();
              // 错误消息提示
              this.$alert(msg, "提示", {
                confirmButtonText: "确定",
                type: "error"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 下载
     * @author 滕威
     */
    fun_Download(filePath) {
      if (filePath) {
        // 下载文件
        fun_Download("/download?filePath=" + filePath).then(res => {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          // 调用下载文件公共方法
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        });
      } else {
        this.$message.error("文件不存在！");
      }
    },
    /**
     * 打开查看核验意见弹窗
     * @author shuhua
     */
    fun_Open(e) {
      // 打开弹窗
      this.dialogVisible = true;
      // 赋值核验意见
      this.auditOpinion = e;
    },
    /**
     * 列表勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 判断是工作人员
      if(this.userType === '201508061647510026' || this.userFlag === '工作人员'){
        // 返回
        this.$router.back();
      }
      // 返回
      this.$emit("fun_Back");
    }
  }
};
